export const findAttrByName = (
	{ attributes: attrs }: Common.IMap<TRANSLATE.IAttributes> = { attributes: {} },
	nodeName: string
): string => {
	return attrs[nodeName.toLowerCase()]?.nodeValue.toString() || '';
};
